














































import Vue from 'vue';
import SectionRow from './SectionRow.vue';
import SectionRowMixin from '@/components/section-row/mixins/SectionRowMixin.vue';
import SectionRowItemMixin from '@/components/section-row/mixins/SectionRowItemMixin.vue';
import { i18n, i18nHints } from '@/plugins/i18n';
import { serializeDate } from '@/utils/date';
import { CvSectionDate, CvSectionDateItem } from '@/../gen';

export default Vue.extend({
  components: {
    SectionRow,
  },
  mixins: [SectionRowMixin, SectionRowItemMixin],
  computed: {
    section(): CvSectionDate {
      return this.cvCvSection.section;
    },
    sectionItems(): CvSectionDateItem[] {
      return this.cvCvSection.sectionItems;
    },
    editLink() {
      return {
        name: 'cv_section_dates_edit_path',
        params: { cv_id: this.section.cv_id, id: this.section.id },
      };
    },
    addLink() {
      return {
        name: 'cv_section_date_items_new_path',
        params: {
          cv_id: this.section.cv_id,
          cv_section_date_id: this.section.id,
        },
      };
    },
  },
  methods: {
    tenureText({
      start_date_year,
      start_date_month,
      start_date_day,
      end_date_year,
      end_date_month,
      end_date_day,
    }) {
      const startDateStr = serializeDate({
        year: start_date_year,
        month: start_date_month,
        day: start_date_day,
      });
      const endDateStr = serializeDate({
        year: end_date_year,
        month: end_date_month,
        day: end_date_day,
      });
      if (startDateStr && endDateStr) return `${startDateStr} 〜 ${endDateStr}`;
      if (startDateStr && !endDateStr)
        return `${startDateStr} 〜 ${i18n.tc(i18nHints.common.label.current)}`;
      if (!startDateStr && endDateStr) return `〜 ${endDateStr}`;
      return '';
    },
    editItemLink(item: CvSectionDateItem) {
      return {
        name: 'cv_section_date_items_edit_path',
        params: {
          cv_id: this.section.cv_id,
          cv_section_date_id: this.section.id,
          id: item.id,
        },
      };
    },
  },
});
